<!-- 礼品发放 grant-->
<template>
  <div class="grant">
    <div class="form_header">
      <el-form ref="form" :model="Gmanform" label-width="100px">
        <div class="form_list">
          <el-form-item label="礼品名称：">
            <el-select v-model="Gmanform.cg_id" placeholder="请选择礼品名称">
              <el-option v-for="item in SpecifList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="来源：">
            <el-select v-model="Gmanform.platform" placeholder="请选择来源">
              <el-option label="pc" :value=1></el-option>
              <el-option label="无线" :value=2></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态：">
            <el-select v-model="Gmanform.status" placeholder="请选择状态">
              <el-option label="已发放" value="1"></el-option>
              <el-option label="未发放" value="0"></el-option>
            </el-select>
          </el-form-item>
          <div class="btn_box">
            <el-button type="primary" @click="onSubmit">搜索</el-button>
            <el-button @click="nosubmint">取消</el-button>
          </div>
        </div>
      </el-form>
      <el-button type="primary" icon="el-icon-upload2" @click="exportlist">导出</el-button>
    </div>
    <div class="user_list">
      <el-table :data="userList" style="width: 100%" @selection-change="handleSelectionChange" :header-cell-style="rowStyle" :cell-style="rowStyle">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="index" label="序号" width="50"></el-table-column>
        <el-table-column prop="name" label="用户名">
          <template slot-scope="scope">
            <span>{{scope.row.user.username}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="order_id" label="订单编号">
          <template slot-scope="scope">
            <span>{{scope.row.order_id}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="email" label="邮箱">
          <template slot-scope="scope">
            <span>{{scope.row.email}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="申请礼品">
          <template slot-scope="scope">
            <span>{{scope.row.category_gift.name}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="礼品秘钥">
          <template slot-scope="scope">
            <span>{{scope.row.gift.secret_key}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="platform" label="来源" >
          <template slot-scope="scope">
            <span v-if="scope.row.platform==1">pc</span>
            <span v-if="scope.row.platform==2">无线</span>
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="时间">
          <template slot-scope="scope">
            <span>{{filterTime(scope.row.created_at)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status==1">已发放</span>
            <span v-if="scope.row.status==0">未发放</span>
          </template>
        </el-table-column>

        <el-table-column fixed="right" label="操作" width="180">
          <template slot-scope="scope">
            <el-button v-if="scope.row.status==0" @click="handleClick(scope.row)" type="text" size="small">发送密钥</el-button>
            <span v-if="scope.row.status==1">已发放</span>
            <!-- <el-button type="text" size="small">编辑</el-button> -->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="fy_box">
      <el-pagination @current-change="handleCurrentChange" background prev-text="上一页" next-text="下一页" :current-page="currentindex" :page-size="pageSize" layout="total,prev, pager, next, jumper" :total="totals"></el-pagination>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { categoryGiftlists } from "../../api/system.js";
import { issuelists, issuesend, issueexport } from "../../api/gift.js";
import { excelexport } from "../../api/comm.js";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      Gmanform: {
        cg_id: "",
        status: "",
        platform: ""
      },
      SpecifList: [],
      userList: [
        {
          user: {
            username: "",
            email: ""
          },
          category_gift: {
            name: ""
          },
          gift: {
            secret_key: ""
          }
        }
      ],
      currentindex: 1,
      pageSize: 10,
      totals: 100,
      Checklist: []
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    rowStyle() {
      return { textAlign: "center" };
    },
    //  时间换算
    filterTime(time) {
      var date = new Date(Number(time + "000"));
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      var h = date.getHours();
      h = h < 10 ? "0" + h : h;
      var minute = date.getMinutes();
      minute = minute < 10 ? "0" + minute : minute;
      var s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return y + "-" + m + "-" + d+" "+h+":"+minute+":"+s;
    },
    //礼品分类
    giftdata() {
      let data = {
        page: "",
        page_size: "",
        currency_id:parseInt(localStorage.getItem('countryId'))
      };
      categoryGiftlists(data).then(res => {
        // console.log(res);
        if (res.status_code == 200) {
          this.SpecifList = res.data.data;
        }
      });
    },
    //发放列表
    isslist() {
      let data = {
        page: this.currentindex,
        page_size: this.pageSize,
        cg_id: this.Gmanform.cg_id,
        status:this.Gmanform.status,
        platform:this.Gmanform.platform,
        currency_id:parseInt(localStorage.getItem('countryId'))
      };
      issuelists(data).then(res => {
        // console.log(res);
        if (res.status_code == 200) {
          this.userList = res.data.data;
          this.totals = res.data.total;
        }
      });
    },
    //分页切换
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.currentindex = val;
      this.isslist();
    },
    //搜索
    onSubmit() {
      // console.log(this.Gmanform);
      this.currentindex = 1;
      this.isslist();
    },
    //取消搜索条件
    nosubmint() {
      this.Gmanform.cg_id = "";
      this.Gmanform.status = "";
      this.Gmanform.platform = ""
      this.currentindex = 1;
      this.isslist();
    },
    //发送密钥
    handleClick(e) {
      // console.log(e);
      let data = {
        id: e.id
      };
      issuesend(data).then(res => {
        // console.log(res);
        if (res.status_code == 200) {
          this.currentindex == 1;
          this.isslist();
          this.$message({
            type: "success",
            message: "发放成功!"
          });
        }
      });
    },
    //选中
    handleSelectionChange(val) {
      // console.log(val);
      this.Checklist = [];
      val.forEach(ele => {
        this.Checklist.push(ele.id);
      });

      // console.log(this.Checklist.join(","));
    },
    //导出
    exportlist() {
      let data = {
        ids: this.Checklist.toString(),
        type: "issue",
        where: {}
      };
      if (this.Gmanform.status == "" && this.Gmanform.cg_id == "") {
        data.where = "";
      } else if (this.Gmanform.status !== "") {
        data.where.status = this.Gmanform.status;
      } else if (this.Gmanform.cg_id !== "") {
        data.where.cg_id = this.Gmanform.cg_id;
      }
      excelexport(data).then(res => {
        // console.log(res);
        const blob = new Blob([res]);
        const downloadElement = document.createElement("a");
        const href = window.URL.createObjectURL(blob); // 创建下载的链接
        downloadElement.href = href;
        downloadElement.download = "礼品发放列表.xlsx"; // 下载后文件名
        document.body.appendChild(downloadElement);
        downloadElement.click(); // 点击下载
        document.body.removeChild(downloadElement); // 下载完成移除元素
        window.URL.revokeObjectURL(href); // 释放掉blob对象
      });
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.giftdata();
    this.isslist();
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
.grant {
  padding: 20px 30px 0;
  .form_header {
    display: flex;
    justify-content: space-between;
    .btn_box {
      margin-left: 20px;
    }
  }
  .form_list {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
  .user_list {
    padding: 20px 0;
  }
}
</style>
<style lang='scss'>
.grant {
  .form_header {
    .el-form-item {
      margin-bottom: 0;
    }
  }

  .el-table {
    border-top: 1px solid #ebeef5;
    border-left: 1px solid #ebeef5;
    border-right: 1px solid #ebeef5;
  }
}
</style>